module.exports = __webpack_public_path__ + "img/menuIcon6.0971bac6.png";